import { render, staticRenderFns } from "./store-alert.vue?vue&type=template&id=18f7a357&scoped=true&"
import script from "./store-alert.vue?vue&type=script&lang=js&"
export * from "./store-alert.vue?vue&type=script&lang=js&"
import style0 from "./store-alert.vue?vue&type=style&index=0&id=18f7a357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7a357",
  null
  
)

export default component.exports